import { PORTAL_UI_V2 } from "../config/uiTheme";
import MachineInfoLegacy from "./machines/MachineInfoLegacy";
import MachineInfoV2 from "./machines/MachineInfoV2";

const MachineInfo = () => (PORTAL_UI_V2 ? <MachineInfoV2 /> : <MachineInfoLegacy />);

export default MachineInfo;
